export default __webpack_public_path__ + "static/inter-v8-latin-regular-c96fe5ff771f9e7b53abe32b27238136.woff2";